export const remove = function (data, item, allSelected) {
  if (!data.filterable && !data.multiple) {
    // noop for basic rich selects since the user can only remove the selected
    // opt by selecting some new option
    return
  }

  if (data.multiple) {
    // For multiple tags
    var active = data.options.filter(function (opt) {
                               return opt.active
                             })[0]

    if (active) {
      active.active = false
      active.selected = false
      data.open = false
      data.emit('change:selected')
    } else if (allSelected.length && !data.searchTerm) {
      allSelected[allSelected.length - 1].active = true
      data.open = false
      data.emit('change:selected')
    }
  } else if (item) {
    item.highlighted = false
    item.selected = false
    data.emit('change:selected')
  }
}

const open = function (data) {
  data.open = true
  data._refreshOptions = true

  // Open menus should not show active tags unless this select allows `changeableTags`
  if (data.multiple && !data.changeableTags) {
    data.options.forEach(function (opt) {
      opt.active = false
    })
  }
  data.emit('change:open')
}

const close = function (data) {
  data.open = false
  data.emit('change:open')
}

export {open, close}

export const select = function (data, items) {
  // If select is invoked and the menu isn't open,
  // then select opens the menu
  if (!data.open) {
    open(data)
    return
  }

  if (!items) {
    return
  }

  items = Array.isArray(items) ? items : [items]

  // If we're selecting a single item, and it's already selected, we don't have to do additional work
  // or emit change events. This matches native select control behavior.
  if (items.length === 1 && items[0].selected) {
    data.open = false
    data.emit('change:open')
    return
  }

  if (!data.multiple) {
    // Make sure no other options are selected
    data.menuOptions.forEach(function (d) {
                      d.selected = false
                      d.highlighted = false
                    })
  }

  items.map(data.mapOnSelect)
       .filter(Boolean) // In case mapOnSelect returns a falsey value meaning they can't add it.
       .forEach(function (item) {
         item.highlighted = false

         if (item.creatable) {
           data.options.push(item)
           delete item.creatable
           data.emit('create:tag', item)
         }
         item.selected = true
       })

  delete data.searchTerm

  data.open = data.stayOpenOnSelect || false
  data.emit('change:selected')
}

export const activateTag = function (data, direction, allSelected) {
  if (!data.multiple) {
    return
  }

  // See if one of the selected tags are already active.
  var active = isNaN(direction) ? direction
                                : allSelected.filter(function (t) {
                                               return t.active
                                             })[0]
    , idx = allSelected.indexOf(active)

  if (idx === -1) {
    idx = allSelected.length - 1
  } else if (!isNaN(direction)) {
    idx += direction
    idx = Math.max(0, idx)
  }

  // Clear other actives
  allSelected.forEach(function (opt) {
    opt.active = false
  })

  if (allSelected[idx]) {
    allSelected[idx].active = true
  }

  if (data.changeableTags) {
    // If a tag is active and the user is allowed to change it, we want to open the menu
    open(data)
  } else {
    close(data)
  }
}
